/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Npi(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <g clipPath="url(#clip0_720_97)">
        <path
          d="M21 13C21 8.31371 21 10.6863 21 6C21 4.343 19.657 3 18 3H6C4.343 3 3 4.343 3 6V18C3 19.657 4.343 21 6 21H12"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7006 8.90909V14H9.77095L7.55611 10.7958H7.51882V14H6.44247V8.90909H7.38707L9.58452 12.1108H9.62926V8.90909H10.7006ZM11.5899 14V8.90909H13.5985C13.9846 8.90909 14.3135 8.98284 14.5853 9.13033C14.8571 9.27616 15.0642 9.47917 15.2068 9.73935C15.3509 9.99787 15.423 10.2962 15.423 10.6342C15.423 10.9723 15.3501 11.2706 15.2043 11.5291C15.0584 11.7876 14.8472 11.989 14.5704 12.1332C14.2953 12.2773 13.9622 12.3494 13.5711 12.3494H12.2909V11.4869H13.3971C13.6043 11.4869 13.7749 11.4512 13.9092 11.38C14.0451 11.3071 14.1462 11.2068 14.2124 11.0792C14.2804 10.9499 14.3144 10.8016 14.3144 10.6342C14.3144 10.4652 14.2804 10.3177 14.2124 10.1918C14.1462 10.0642 14.0451 9.96555 13.9092 9.89595C13.7733 9.82469 13.6009 9.78906 13.3921 9.78906H12.6663V14H11.5899ZM17.1985 8.90909V14H16.1222V8.90909H17.1985Z"
          fill={color}
        />
        <path
          d="M18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16C17.1193 16 16 17.1193 16 18.5C16 19.8807 17.1193 21 18.5 21Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 22L21 21"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_720_97">
          <rect width="24" height="24" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}

Npi.defaultProps = {
  color: "currentColor",
  size: 24,
};

Npi.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
